export default __webpack_public_path__ + "static/media/history-contract.c3e0dde5.svg";